import React from "react"
import { FormattedMessage, useIntl } from "react-intl"

import UseStoryBlogData from "../../../hooks/useStoryBlogData"
import StoryCard from "../../internal/storyCard/StoryCard"

function TruncateString(str,limit) {
  if(str && str.length > limit) {
    return str.substring(0, limit) + "..."
  }
  return str
}

function StoryCardWidget({ blok }) {
  const stories = UseStoryBlogData()

  let story = stories.find((s)=>{ return s.uuid === blok.story })
  
  if(story) {
    return (
      <StoryCard
        image={story.image}
        thumbnail={story.thumbnail}
        label={blok.type_label}
        headline={story.headline}
        excerpt={TruncateString(story.excerpt, 120)}
        cta_text={(<FormattedMessage id="component.panel.story_listing_panel.cta"/>)}
        cta_link={story.link} />
    )
  } 

  return (
    <></>
  )
}


export default StoryCardWidget